export class UpdateOffboardingResgnStatus {
  OffboardingID: number;
  EmpCode: number;
  ResignationDate: Date;
  IndicativeLWD: Date;
  LastWorkingDay: Date;
  ExitID: number;
  ReasonID: number;
  status: string;
  Designation: string;
  ManagerResignationComments: string;
  HRResignationComments: string;
  ModifiedBy: string;
  IsManagerApprReject: boolean;
  CC: string;
  Comments: string;
  ProjectManagers: string;
}
